import FilterRequests from "./FilterRequestsClass";

export default class FilterProducts extends FilterRequests{
    constructor (argFilter) {
       super();
       this.containter = $(argFilter.container);
       this.filterUrl = argFilter.filterUrl;
       this.fastFiltersCl = argFilter.fastFiltersCl;
       this.filtersCl = argFilter.filtersCl;
       this.params = argFilter.params;
       this.categoryFiltersCl = argFilter.categoryFiltersCl;
       this.brandsFiltersCl = argFilter.brandsFiltersCl;
       this.sortFlag = false;

       this.actions();
    }

    /**
     *
     * @param params
     */
    setParams (params) {
        this.params = $.extend(this.params, params);
        this.refresh();
    };

    /**
     *
     * @param name
     * @returns {null|*}
     */
    getParam (name) {
        if (name in this.params) {
            return this.params[name];
        }
        return null;
    };

    refresh () {
        let self = this;

        self.preloader(true);
        let req = this.post(this.filterUrl, this.params);

        req.then(function (resp) {
            $.each(resp.replace, function (name, code) {
                $('#xhr-' + name).html(code);
            });
            $.each(resp.append, function (name, code) {
                $('#xhr-' + name).append(code);
            });
            history.replaceState({}, null, resp.url);

            //GO TOP IF CHANGE FILTER|PAGINATE
            if(resp.append.length === 0) {
                self.scrollToTop();
            }

            self.containter.trigger('initial.range.values');
            self.containter.trigger('initial.product.carousel');

            //
            if($(window).width() >= 1200) {
                $('.product-card').each(function () {
                    let self = $(this);
                    $(this).find('img').bind('load', function() {
                        self.parent().css('min-height', self.outerHeight());
                    });
                });
            }
        });

        req.always(function () {
            self.preloader(false, self.params.resetAll);
        });
    }

    /**
     * All actions
     */
    actions() {
        let self = this;

        //Categories (Search Page)
        this.containter.on('change', this.categoryFiltersCl, function() {
            let obj = {};
            obj['categories'] = [];
            $(this).closest('.accordion-item__body').find('input[type=checkbox]:checked').each(function () {
                obj['categories'].push($(this).val());
            });

            obj['page'] = 1;
            obj['start'] = 1;

            self.setParams(obj);
        });

        //Brands (Search Page)
        this.containter.on('change', this.brandsFiltersCl, function() {
            let obj = {};
            obj['brands'] = [];
            $(this).closest('.accordion-item__body').find('input[type=checkbox]:checked').each(function () {
                obj['brands'].push($(this).attr('name'));
            });

            obj['page'] = 1;
            obj['start'] = 1;

            self.setParams(obj);
        });

        // Sorting
        if(this.fastFiltersCl) {
            this.containter.on('click', this.fastFiltersCl, function(e) {
                e.preventDefault();

                $(this).closest('ul').find('.active').removeClass('active');
                $(this).find('a').addClass('active');

                let $parent = $(this).closest('.sort-wrap'),
                    f = $parent.find('li[data-f] a.active').parent().attr('data-f'),
                    d = $parent.find('li[data-direct] a.active').parent().attr('data-direct');

                if (!f && !d) {
                    return;
                }
                let params = {sort: f + '_' + d};
                params['page'] = 1;
                params['start'] = 1;
                //self.sortFlag = true;
                self.setParams(params);
            });
        }

        //Filters
        this.containter.on('change', this.filtersCl, function() {
            let name = $(this).attr('name');
            if (!name) {
                return;
            }
            let $selected = self.containter.find(self.filtersCl + '[name="'+name+'"]:checked');

            let isArray = false;
            if (name.substr(-2) === '[]') {
                isArray = true;
                name = name.substr(0, name.length - 2);
            }

            let obj = {};
            if ($selected.length) {
                // добавить фильтр
                $selected.each(function () {
                    let value = $(this).attr('value');
                    if (isArray) {
                        if (!obj.hasOwnProperty(name)) {
                            obj[name] = [];
                        }
                        obj[name].push(value);
                    } else {
                        obj[name] = value;
                    }
                });
            } else {
                // сброс фильтра
                obj[name] = isArray ? [] : null;
            }

            obj['page'] = 1;
            obj['start'] = 1;

            self.setParams(obj);
        });

        //Price ranges
        this.containter.bind('price.change.watching', function (e, min_val, max_val, min, max) {
            let valFrom = Number(min_val),
                valTo = Number(max_val);

            if (isNaN(valFrom) || isNaN(valTo) || valFrom > valTo) {
                return;
            }

            let valFromDefault = Number(min),
                valToDefault = Number(max),
                valParam = valFrom + '-' + valTo;

            if (Math.abs(valFrom - valFromDefault) < 0.001 && Math.abs(valTo - valToDefault) < 0.001) {
                valParam = null;
            }

            self.setParams({
                prices: [],
                price: valParam,
                page: 1,
                start: 1
            });
        });

        //Load more
        this.containter.on('click', '.load_more_btn', function(e) {
            e.preventDefault();

            let page = parseInt(self.getParam('page'));
            self.setParams({
                page: page + 1
            });
        });

        //Pagination
        this.containter.on('click', '.pagination-block li[data-p]', function(e) {
            e.preventDefault();

            let page = $(this).attr('data-p');
            self.setParams({
                start: page,
                page: page
            });
        });

        //Reset all
        this.containter.on('click', '#reset-all, #reset-all-small', function(e) {
            e.preventDefault();

            //Сheckbox
            $(self.filtersCl).each(function () {
                $(this).prop('checked', false);
            });

            self.setParams({
                prices: [],
                price: null,
                brands: [],
                values: [],
                categories: [],
                page: 1,
                start: 1,
                resetAll: true
            });
        });
    }
}
